import type { AdminAuthUser } from '@/contexts/auth-context'

/** DEC-ADMIN-013 — the two admin surfaces (mirrors the backend AdminSurface). */
export type AdminSurface = 'moderation' | 'operations'

export type AdminRole = NonNullable<AdminAuthUser['role']>

/**
 * Whether an admin role may access a surface — mirrors the backend
 * AdminRole::canAccess (the backend is the real gate; this just drives the UI:
 * nav visibility + client-side route guards).
 */
export function canAccessSurface(role: AdminRole | undefined, surface: AdminSurface): boolean {
  switch (role) {
    case 'admin':
      return true
    case 'user_admin':
      return surface === 'moderation'
    case 'ops_admin':
      return surface === 'operations'
    default:
      return false
  }
}
